import { ReturnBackButton } from '../../return-back-button.component'
import { SwitchFormWrapper } from './switch-form-wrapper.component'
import { E2FAMethod, E2FAMethodTab } from 'src/types'

interface IProps {
  method: E2FAMethod | null
  subTab: E2FAMethodTab
  returnBack: () => void
}

export const SwitchTotp2FA = ({ method, subTab, returnBack }: IProps) => {
  if (subTab !== E2FAMethodTab.Switch || !method) {
    return null
  }

  return (
    <div>
      <ReturnBackButton returnBack={returnBack} />
      <SwitchFormWrapper />
    </div>
  )
}
